// extracted by mini-css-extract-plugin
export default {"container":"SettingsSubMenu_container__lK5sM","menuContainer":"SettingsSubMenu_menuContainer__8YGcf"};